declare global {
    interface Window {
        grecaptcha?: {
            ready: (cb: () => void) => void;
            execute: (siteKey: string, opts: { action: string }) => Promise<string>;
        };
    }
}

let loadingPromise: Promise<void> | null = null;

export function loadRecaptcha(siteKey: string): Promise<void> {
    if (window.grecaptcha) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    loadingPromise = new Promise<void>((resolve, reject) => {
        const existing = document.querySelector('script[data-recaptcha="v3"]') as HTMLScriptElement | null;
        if (existing) {
            existing.addEventListener("load", () => resolve());
            existing.addEventListener("error", () => reject(new Error("Failed to load reCAPTCHA script")));
            return;
        }

        const s = document.createElement("script");
        s.dataset.recaptcha = "v3";
        s.src = "https://www.google.com/recaptcha/api.js?render=" + encodeURIComponent(siteKey);
        s.async = true;
        s.defer = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
        document.head.appendChild(s);
    });

    return loadingPromise;
}
